import logo from '../assets/images/logo-banner.png';
import logoBkp from '../logo - backup.svg';
import '../App.css';
import backgroundVideo from '../assets/videos/DundagAI_1.webm';

function HomePage() {
  return (
    <div className="App">
      <header className="App-header">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="video-background"
        >
          <source src={backgroundVideo} type="video/webm" />
        </video>
        <div className="dark-overlay" style={{ 
          position: 'absolute', 
          top: 0, 
          left: 0, 
          width: '100%', 
          height: '100%', 
          backgroundColor: 'rgba(0, 0, 0, 0.5)', 
          zIndex: 1 
        }} />
        
        {/* Content container */}
        <div className="content-container">
          {/* Logo */}
          <img 
            src={logo} 
            className="logo-image"
            style={{ 
              position: 'absolute', 
              top: '20px', 
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100%',
              maxWidth: '600px'
            }}
            alt="logo"
          />
          <div className="spinning-logo-container" style={{ 
            position: 'absolute', 
            top: '50%', 
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 2 
          }}>
            <img src={logoBkp} className="spinning-logo" alt="Spinning Logo" />
          </div>
          {/* Text content */}
          <div className="text-content">
            <div>
              Šeit top pašapkalpošanās tirgus
              <div>portāls DundagAI.lv</div>
            </div>
            <div>
              Modernākais lauku vides tirgus
              <div>risinājums Latvijā!</div>
              <button 
                className="register-button"
                onClick={() => window.location.href = '/login'}
              >
                Reģistrēties
              </button>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default HomePage;
